import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { useToasts } from './complex/Toast'
import { useAuth } from '../utils/auth'
import { t } from '../utils/i18n'

/**
 * Component to handle PCO OAuth success redirect
 * Checks for ?pco_auth=success query parameter and shows a success message
 */
const PcoAuthSuccessHandler: React.FC = () => {
  const router = useRouter()
  const { addToast } = useToasts()
  const { refetchCurrentUser } = useAuth()

  useEffect(() => {
    if (router.query.pco_auth === 'success') {
      addToast(
        t(
          'You successfully connected your Planning Center Online account. You can now add songs to your PCO account.'
        ),
        'primary'
      )

      // Refetch user data to update PCO account status
      refetchCurrentUser()

      // Remove the query parameter from URL without reloading
      const { pco_auth, ...restQuery } = router.query
      router.replace(
        {
          pathname: router.pathname,
          query: restQuery
        },
        undefined,
        { shallow: true }
      )
    }
  }, [router.query, router, addToast, refetchCurrentUser])

  return null
}

export default PcoAuthSuccessHandler
